export const LANGS = [
  { code: "de", label: "Deutsch" },
  { code: "en", label: "English" },
  { code: "tr", label: "Türkçe" },
];

export const translations = {
  de: {
    nav_home: "Start",
    nav_collections: "Kollektionen",
    nav_appointment: "Termin buchen",
    nav_manage: "Mein Termin",
    nav_location: "Anfahrt",
    nav_admin: "Admin",

    hero_eyebrow: "Haute Couture · Stuttgart",
    hero_title: "Ihr Moment. Maßgeschneidert bei Veloura.",
    hero_sub: "Brautmode, Abendkleider, Henna- & Verlobungskleidung und Herrenanzüge. Vereinbaren Sie Ihren persönlichen Beratungstermin in unserem Atelier in Stuttgart.",
    hero_cta: "Termin vereinbaren",
    hero_cta2: "Kollektionen entdecken",

    collections_title: "Unsere Welten",
    collections_sub: "Für jeden besonderen Anlass",

    cat_brautmode: "Brautmode",
    cat_abendkleider: "Abendkleider / Gala",
    cat_hennakleidung: "Hennakleidung",
    cat_verlobungskleidung: "Verlobungskleidung",
    cat_herrenanzuege: "Herrenanzüge",
    cat_brautmode_desc: "Zeitlose Brautkleider für den schönsten Tag.",
    cat_abendkleider_desc: "Glamouröse Roben für Gala und Abend.",
    cat_hennakleidung_desc: "Farbenprächtige Kleider für Ihre Henna-Nacht.",
    cat_verlobungskleidung_desc: "Eleganz für den Tag Ihres Versprechens.",
    cat_herrenanzuege_desc: "Maßgefertigte Anzüge und Smokings.",
    book_this: "Termin für diese Auswahl",

    about_title: "Das Veloura Atelier",
    about_text: "Seit Jahren kleiden wir unsere Kundinnen und Kunden für die wichtigsten Momente ihres Lebens. Persönliche Beratung, feinste Stoffe und meisterhafte Schneiderkunst – in einer Atmosphäre voller Ruhe und Eleganz.",

    booking_title: "Termin buchen",
    booking_sub: "In vier einfachen Schritten zu Ihrer persönlichen Beratung",
    step: "Schritt",
    of: "von",
    step1_title: "Auswahl der Kollektion",
    step2_title: "Datum & Uhrzeit",
    step3_title: "Ihre Angaben",
    step4_title: "Übersicht & Bestätigung",
    choose_date: "Datum wählen",
    choose_time: "Uhrzeit wählen",
    morning: "Vormittags",
    afternoon: "Nachmittags",
    evening: "Abends",
    full_name: "Vollständiger Name",
    email: "E-Mail",
    phone: "Telefon",
    guests: "Anzahl Begleitpersonen",
    notes: "Besondere Wünsche (optional)",
    back: "Zurück",
    next: "Weiter",
    confirm_booking: "Termin anfragen",
    summary_category: "Kollektion",
    summary_datetime: "Datum & Uhrzeit",
    summary_name: "Name",

    success_title: "Vielen Dank!",
    success_text: "Ihre Terminanfrage wurde erhalten. Wir prüfen sie und senden Ihnen eine Bestätigung per E-Mail. Ihre Buchungsreferenz:",
    success_hint: "Bewahren Sie diese Referenz auf, um Ihren Termin später einzusehen oder zu ändern.",
    book_another: "Weiteren Termin buchen",

    manage_title: "Mein Termin",
    manage_sub: "Termin einsehen, ändern oder stornieren",
    ref_label: "Buchungsreferenz (z. B. VLR-ABC123)",
    lookup: "Termin suchen",
    status: "Status",
    status_pending: "In Prüfung",
    status_approved: "Bestätigt",
    status_rejected: "Abgelehnt",
    status_rescheduled: "Verschoben",
    status_cancelled: "Storniert",
    modify_title: "Termin ändern",
    modify_hint: "Änderungen sind bis 24 Stunden vor dem Termin möglich.",
    cannot_modify: "Dieser Termin kann nicht mehr geändert werden (weniger als 24 Stunden verbleibend).",
    save_changes: "Änderungen speichern",
    cancel_appt: "Termin stornieren",
    confirm_cancel: "Möchten Sie diesen Termin wirklich stornieren?",
    add_calendar: "Zum Kalender (.ics)",
    add_google: "Google Kalender",
    open_maps: "Route (Maps)",
    admin_message_label: "Nachricht vom Atelier",

    location_title: "Besuchen Sie uns",
    opening_hours: "Öffnungszeiten",
    hours_week: "Mo – Fr: 10:00 – 19:00",
    hours_sat: "Sa: 10:00 – 18:00",
    hours_sun: "So: geschlossen",

    admin_login_title: "Admin Anmeldung",
    password: "Passwort",
    login: "Anmelden",
    logout: "Abmelden",
    forgot_password: "Passwort vergessen?",
    dashboard: "Übersicht",
    calendar: "Kalender",
    appointments: "Termine",
    staff: "Mitarbeiter",
    filter_status: "Status",
    filter_category: "Kollektion",
    all: "Alle",
    approve: "Bestätigen",
    reject: "Ablehnen",
    reschedule: "Verschieben",
    export_csv: "CSV Export",
    total: "Gesamt",
    pending: "In Prüfung",
    approved: "Bestätigt",
    upcoming: "Anstehend",
    message_optional: "Nachricht (optional)",
    send: "Senden",
    internal_notes: "Interne Notizen",
    save: "Speichern",
    add_staff: "Mitarbeiter hinzufügen",
    role: "Rolle",
    super_admin: "Super Admin",
    stylist: "Stylist",
    remove: "Entfernen",
    guest: "Gast",
    required_field: "Bitte füllen Sie dieses Feld aus.",
    nav_contact: "Kontakt",
    contact_title: "Kontakt",
    contact_sub: "Haben Sie eine Frage? Schreiben Sie uns.",
    contact_message: "Ihre Nachricht",
    contact_send: "Nachricht senden",
    contact_success: "Vielen Dank! Wir melden uns so schnell wie möglich.",
    theme_choose_title: "Wie möchten Sie Veloura erleben?",
    theme_choose_sub: "Wählen Sie Ihre bevorzugte Ansicht. Sie können jederzeit wechseln.",
    theme_light: "Hell",
    theme_dark: "Dunkel",
    settings_tab: "Einstellungen",
    opening_hours_title: "Öffnungszeiten",
    slot_interval_label: "Termin-Intervall (Minuten)",
    closed: "Geschlossen",
    open_from: "Von",
    open_to: "Bis",
    images_title: "Bilder verwalten",
    upload: "Hochladen",
    messages_tab: "Nachrichten",
    no_slots: "An diesem Tag geschlossen. Bitte wählen Sie ein anderes Datum.",
    nav_accessories: "Accessoires",
    nav_collections: "Kollektionen",
    nav_about: "Über uns",
    nav_blog: "Magazin",
    featured_title: "Neu & Beliebt",
    featured_sub: "Entdecken Sie unsere aktuellen Lieblingsstücke",
    whyus_title: "Warum Veloura",
    whyus_sub: "Was uns besonders macht",
    how_title: "So einfach geht Ihr Termin",
    how_sub: "In drei Schritten zu Ihrem perfekten Look",
    testimonials_title: "Was unsere Kundinnen sagen",
    testimonials_sub: "Echte Erlebnisse aus unserem Atelier",
    visit_title: "Besuchen Sie unser Atelier",
    plan_appointment: "Termin planen",
    discover_collection: "Kollektion entdecken",
    view_all: "Alle ansehen",
    read_more: "Weiterlesen",
    learn_more: "Mehr erfahren",
    back_to_blog: "Zurück zum Magazin",
    no_products_yet: "Bald verfügbar. Vereinbaren Sie einen Termin für eine persönliche Beratung.",
    blog_title: "Magazin & Inspiration",
    blog_sub: "Tipps, Trends und Geschichten rund um Ihren besonderen Tag",
    content_tab: "Inhalt",
    products_tab: "Kollektionen",
    blog_tab: "Magazin",
    theme_tab: "Farben",
    testimonials_tab: "Bewertungen",
    add_item: "Hinzufügen",
    title_label: "Titel",
    description_label: "Beschreibung",
    image_label: "Bild",
    body_label: "Inhalt",
    excerpt_label: "Kurzbeschreibung",
    published_label: "Veröffentlicht",
    order_label: "Reihenfolge",
    delete_label: "Löschen",
    edit_label: "Bearbeiten",
    cancel_label: "Abbrechen",
    rating_label: "Sterne",
    name_label: "Name",
    edit_language: "Sprache bearbeiten",
    hero_title_label: "Hero Titel",
    hero_subtitle_label: "Hero Untertitel",
    about_title_label: "Über uns – Titel",
    about_text_label: "Über uns – Text",
    subcategory_label: "Unterkategorie (optional)",
    social_label: "Soziale Medien",
    theme_gold: "Gold / Akzent",
    theme_gold_light: "Gold hell",
    theme_dark_bg: "Dunkel – Hintergrund",
    theme_dark_card: "Dunkel – Karten",
    theme_dark_text: "Dunkel – Text",
    theme_dark_muted: "Dunkel – Text gedämpft",
    theme_light_bg: "Hell – Hintergrund",
    theme_light_card: "Hell – Karten",
    theme_light_text: "Hell – Text",
    theme_light_muted: "Hell – Text gedämpft",
    pages_tab: "Seiten",
    page_new: "Neue Seite",
    page_back: "Zurück",
    page_title_ph: "Seitentitel",
    page_hero: "Titelbild (Hero, optional)",
    page_show_nav: "Im Menü",
    page_published: "Veröffentlicht",
    page_add_heading: "Überschrift",
    page_add_text: "Text",
    page_add_image: "Bild",
    page_block_caption: "Bildunterschrift (optional)",
    page_no_pages: "Noch keine Seiten. Erstellen Sie Ihre erste Seite.",
    page_delete_confirm: "Diese Seite wirklich löschen?",
    page_not_found: "Seite nicht gefunden",
    img_hero: "Hero / Startbild",
    img_store: "Atelier",
    view_image: "Bild ansehen",
  },

  en: {
    nav_home: "Home",
    nav_collections: "Collections",
    nav_appointment: "Book appointment",
    nav_manage: "My appointment",
    nav_location: "Location",
    nav_admin: "Admin",

    hero_eyebrow: "Haute Couture · Stuttgart",
    hero_title: "Your moment. Tailored at Veloura.",
    hero_sub: "Bridal wear, gala gowns, henna & engagement attire and men's suits. Book your personal styling appointment at our Stuttgart atelier.",
    hero_cta: "Book appointment",
    hero_cta2: "Explore collections",

    collections_title: "Our worlds",
    collections_sub: "For every special occasion",

    cat_brautmode: "Bridal Wear",
    cat_abendkleider: "Gala & Evening",
    cat_hennakleidung: "Henna Attire",
    cat_verlobungskleidung: "Engagement Attire",
    cat_herrenanzuege: "Men's Suits",
    cat_brautmode_desc: "Timeless wedding gowns for your special day.",
    cat_abendkleider_desc: "Glamorous robes for gala and evening.",
    cat_hennakleidung_desc: "Vibrant dresses for your henna night.",
    cat_verlobungskleidung_desc: "Elegance for the day of your promise.",
    cat_herrenanzuege_desc: "Bespoke suits and tuxedos.",
    book_this: "Book for this selection",

    about_title: "The Veloura Atelier",
    about_text: "For years we have dressed our clients for the most important moments of their lives. Personal advice, the finest fabrics and masterful tailoring — in an atmosphere of calm and elegance.",

    booking_title: "Book an appointment",
    booking_sub: "Four simple steps to your personal consultation",
    step: "Step",
    of: "of",
    step1_title: "Choose your collection",
    step2_title: "Date & time",
    step3_title: "Your details",
    step4_title: "Summary & confirmation",
    choose_date: "Choose date",
    choose_time: "Choose time",
    morning: "Morning",
    afternoon: "Afternoon",
    evening: "Evening",
    full_name: "Full name",
    email: "Email",
    phone: "Phone",
    guests: "Number of guests",
    notes: "Special wishes (optional)",
    back: "Back",
    next: "Next",
    confirm_booking: "Request appointment",
    summary_category: "Collection",
    summary_datetime: "Date & time",
    summary_name: "Name",

    success_title: "Thank you!",
    success_text: "Your appointment request has been received. We will review it and send you a confirmation by email. Your booking reference:",
    success_hint: "Keep this reference to view or change your appointment later.",
    book_another: "Book another appointment",

    manage_title: "My appointment",
    manage_sub: "View, change or cancel your appointment",
    ref_label: "Booking reference (e.g. VLR-ABC123)",
    lookup: "Find appointment",
    status: "Status",
    status_pending: "Under review",
    status_approved: "Confirmed",
    status_rejected: "Declined",
    status_rescheduled: "Rescheduled",
    status_cancelled: "Cancelled",
    modify_title: "Change appointment",
    modify_hint: "Changes are possible up to 24 hours before the appointment.",
    cannot_modify: "This appointment can no longer be changed (less than 24 hours remaining).",
    save_changes: "Save changes",
    cancel_appt: "Cancel appointment",
    confirm_cancel: "Do you really want to cancel this appointment?",
    add_calendar: "Add to calendar (.ics)",
    add_google: "Google Calendar",
    open_maps: "Route (Maps)",
    admin_message_label: "Message from the atelier",

    location_title: "Visit us",
    opening_hours: "Opening hours",
    hours_week: "Mon – Fri: 10:00 – 19:00",
    hours_sat: "Sat: 10:00 – 18:00",
    hours_sun: "Sun: closed",

    admin_login_title: "Admin login",
    password: "Password",
    login: "Sign in",
    logout: "Sign out",
    forgot_password: "Forgot password?",
    dashboard: "Dashboard",
    calendar: "Calendar",
    appointments: "Appointments",
    staff: "Staff",
    filter_status: "Status",
    filter_category: "Collection",
    all: "All",
    approve: "Approve",
    reject: "Decline",
    reschedule: "Reschedule",
    export_csv: "Export CSV",
    total: "Total",
    pending: "Pending",
    approved: "Approved",
    upcoming: "Upcoming",
    message_optional: "Message (optional)",
    send: "Send",
    internal_notes: "Internal notes",
    save: "Save",
    add_staff: "Add staff",
    role: "Role",
    super_admin: "Super Admin",
    stylist: "Stylist",
    remove: "Remove",
    guest: "guest",
    required_field: "Please fill in this field.",
    nav_contact: "Contact",
    contact_title: "Contact",
    contact_sub: "Have a question? Write to us.",
    contact_message: "Your message",
    contact_send: "Send message",
    contact_success: "Thank you! We will get back to you as soon as possible.",
    theme_choose_title: "How would you like to experience Veloura?",
    theme_choose_sub: "Choose your preferred view. You can switch anytime.",
    theme_light: "Light",
    theme_dark: "Dark",
    settings_tab: "Settings",
    opening_hours_title: "Opening hours",
    slot_interval_label: "Appointment interval (minutes)",
    closed: "Closed",
    open_from: "From",
    open_to: "To",
    images_title: "Manage images",
    upload: "Upload",
    messages_tab: "Messages",
    no_slots: "Closed on this day. Please choose another date.",
    nav_accessories: "Accessories",
    nav_collections: "Collections",
    nav_about: "About us",
    nav_blog: "Magazine",
    featured_title: "New & Loved",
    featured_sub: "Discover our current favourites",
    whyus_title: "Why Veloura",
    whyus_sub: "What makes us special",
    how_title: "Your appointment made easy",
    how_sub: "Three steps to your perfect look",
    testimonials_title: "What our clients say",
    testimonials_sub: "Real experiences from our atelier",
    visit_title: "Visit our atelier",
    plan_appointment: "Plan appointment",
    discover_collection: "Discover collection",
    view_all: "View all",
    read_more: "Read more",
    learn_more: "Learn more",
    back_to_blog: "Back to magazine",
    no_products_yet: "Coming soon. Book an appointment for a personal consultation.",
    blog_title: "Magazine & Inspiration",
    blog_sub: "Tips, trends and stories around your special day",
    content_tab: "Content",
    products_tab: "Collections",
    blog_tab: "Magazine",
    theme_tab: "Colours",
    testimonials_tab: "Reviews",
    add_item: "Add",
    title_label: "Title",
    description_label: "Description",
    image_label: "Image",
    body_label: "Content",
    excerpt_label: "Excerpt",
    published_label: "Published",
    order_label: "Order",
    delete_label: "Delete",
    edit_label: "Edit",
    cancel_label: "Cancel",
    rating_label: "Stars",
    name_label: "Name",
    edit_language: "Edit language",
    hero_title_label: "Hero title",
    hero_subtitle_label: "Hero subtitle",
    about_title_label: "About – title",
    about_text_label: "About – text",
    subcategory_label: "Subcategory (optional)",
    social_label: "Social media",
    theme_gold: "Gold / Accent",
    theme_gold_light: "Gold light",
    theme_dark_bg: "Dark – background",
    theme_dark_card: "Dark – cards",
    theme_dark_text: "Dark – text",
    theme_dark_muted: "Dark – text muted",
    theme_light_bg: "Light – background",
    theme_light_card: "Light – cards",
    theme_light_text: "Light – text",
    theme_light_muted: "Light – text muted",
    pages_tab: "Pages",
    page_new: "New page",
    page_back: "Back",
    page_title_ph: "Page title",
    page_hero: "Hero image (optional)",
    page_show_nav: "In menu",
    page_published: "Published",
    page_add_heading: "Heading",
    page_add_text: "Text",
    page_add_image: "Image",
    page_block_caption: "Caption (optional)",
    page_no_pages: "No pages yet. Create your first page.",
    page_delete_confirm: "Really delete this page?",
    page_not_found: "Page not found",
    img_hero: "Hero image",
    img_store: "Atelier",
    view_image: "View image",
  },

  tr: {
    nav_home: "Ana sayfa",
    nav_collections: "Koleksiyonlar",
    nav_appointment: "Randevu al",
    nav_manage: "Randevum",
    nav_location: "Konum",
    nav_admin: "Yönetim",

    hero_eyebrow: "Haute Couture · Stuttgart",
    hero_title: "Anınız. Veloura'da size özel.",
    hero_sub: "Gelinlik, abiye & gala, kına ve nişan kıyafetleri ile erkek takımları. Stuttgart atölyemizde kişisel danışmanlık randevunuzu alın.",
    hero_cta: "Randevu al",
    hero_cta2: "Koleksiyonları keşfet",

    collections_title: "Dünyalarımız",
    collections_sub: "Her özel an için",

    cat_brautmode: "Gelinlik",
    cat_abendkleider: "Abiye / Gala",
    cat_hennakleidung: "Kına Kıyafeti",
    cat_verlobungskleidung: "Nişan Kıyafeti",
    cat_herrenanzuege: "Erkek Takımları",
    cat_brautmode_desc: "Özel gününüz için zamansız gelinlikler.",
    cat_abendkleider_desc: "Gala ve geceler için göz alıcı tasarımlar.",
    cat_hennakleidung_desc: "Kına geceniz için canlı renkli kıyafetler.",
    cat_verlobungskleidung_desc: "Söz gününüz için zarafet.",
    cat_herrenanzuege_desc: "Özel dikim takımlar ve smokinler.",
    book_this: "Bu seçim için randevu",

    about_title: "Veloura Atölyesi",
    about_text: "Yıllardır müşterilerimizi hayatlarının en önemli anları için giydiriyoruz. Kişisel danışmanlık, en kaliteli kumaşlar ve usta terzilik — huzur ve zarafet dolu bir atmosferde.",

    booking_title: "Randevu al",
    booking_sub: "Kişisel danışmanlığınıza dört kolay adımda",
    step: "Adım",
    of: "/",
    step1_title: "Koleksiyon seçimi",
    step2_title: "Tarih & saat",
    step3_title: "Bilgileriniz",
    step4_title: "Özet & onay",
    choose_date: "Tarih seçin",
    choose_time: "Saat seçin",
    morning: "Sabah",
    afternoon: "Öğleden sonra",
    evening: "Akşam",
    full_name: "Ad soyad",
    email: "E-posta",
    phone: "Telefon",
    guests: "Refakatçi sayısı",
    notes: "Özel istekler (opsiyonel)",
    back: "Geri",
    next: "İleri",
    confirm_booking: "Randevu talep et",
    summary_category: "Koleksiyon",
    summary_datetime: "Tarih & saat",
    summary_name: "Ad",

    success_title: "Teşekkürler!",
    success_text: "Randevu talebiniz alındı. İnceleyip size e-posta ile onay göndereceğiz. Randevu referansınız:",
    success_hint: "Randevunuzu daha sonra görüntülemek veya değiştirmek için bu referansı saklayın.",
    book_another: "Başka randevu al",

    manage_title: "Randevum",
    manage_sub: "Randevunuzu görüntüleyin, değiştirin veya iptal edin",
    ref_label: "Randevu referansı (örn. VLR-ABC123)",
    lookup: "Randevu bul",
    status: "Durum",
    status_pending: "İnceleniyor",
    status_approved: "Onaylandı",
    status_rejected: "Reddedildi",
    status_rescheduled: "Ertelendi",
    status_cancelled: "İptal edildi",
    modify_title: "Randevuyu değiştir",
    modify_hint: "Değişiklikler randevudan 24 saat öncesine kadar yapılabilir.",
    cannot_modify: "Bu randevu artık değiştirilemez (24 saatten az kaldı).",
    save_changes: "Değişiklikleri kaydet",
    cancel_appt: "Randevuyu iptal et",
    confirm_cancel: "Bu randevuyu gerçekten iptal etmek istiyor musunuz?",
    add_calendar: "Takvime ekle (.ics)",
    add_google: "Google Takvim",
    open_maps: "Yol tarifi (Maps)",
    admin_message_label: "Atölyeden mesaj",

    location_title: "Bizi ziyaret edin",
    opening_hours: "Çalışma saatleri",
    hours_week: "Pzt – Cum: 10:00 – 19:00",
    hours_sat: "Cmt: 10:00 – 18:00",
    hours_sun: "Paz: kapalı",

    admin_login_title: "Yönetici girişi",
    password: "Şifre",
    login: "Giriş yap",
    logout: "Çıkış yap",
    forgot_password: "Şifremi unuttum?",
    dashboard: "Panel",
    calendar: "Takvim",
    appointments: "Randevular",
    staff: "Personel",
    filter_status: "Durum",
    filter_category: "Koleksiyon",
    all: "Tümü",
    approve: "Onayla",
    reject: "Reddet",
    reschedule: "Ertele",
    export_csv: "CSV indir",
    total: "Toplam",
    pending: "Beklemede",
    approved: "Onaylı",
    upcoming: "Yaklaşan",
    message_optional: "Mesaj (opsiyonel)",
    send: "Gönder",
    internal_notes: "İç notlar",
    save: "Kaydet",
    add_staff: "Personel ekle",
    role: "Rol",
    super_admin: "Süper Yönetici",
    stylist: "Stilist",
    remove: "Kaldır",
    guest: "misafir",
    required_field: "Lütfen bu alanı doldurun.",
    nav_contact: "İletişim",
    contact_title: "İletişim",
    contact_sub: "Sorunuz mu var? Bize yazın.",
    contact_message: "Mesajınız",
    contact_send: "Mesaj gönder",
    contact_success: "Teşekkürler! En kısa sürede size döneceğiz.",
    theme_choose_title: "Veloura'yı nasıl deneyimlemek istersiniz?",
    theme_choose_sub: "Tercih ettiğiniz görünümü seçin. İstediğiniz zaman değiştirebilirsiniz.",
    theme_light: "Açık",
    theme_dark: "Koyu",
    settings_tab: "Ayarlar",
    opening_hours_title: "Çalışma saatleri",
    slot_interval_label: "Randevu aralığı (dakika)",
    closed: "Kapalı",
    open_from: "Başlangıç",
    open_to: "Bitiş",
    images_title: "Görselleri yönet",
    upload: "Yükle",
    messages_tab: "Mesajlar",
    no_slots: "Bu gün kapalı. Lütfen başka bir tarih seçin.",
    nav_accessories: "Aksesuarlar",
    nav_collections: "Koleksiyonlar",
    nav_about: "Hakkımızda",
    nav_blog: "Dergi",
    featured_title: "Yeni & Beğenilen",
    featured_sub: "Güncel favorilerimizi keşfedin",
    whyus_title: "Neden Veloura",
    whyus_sub: "Bizi özel kılan şeyler",
    how_title: "Randevunuz çok kolay",
    how_sub: "Mükemmel görünümünüze üç adımda",
    testimonials_title: "Müşterilerimiz ne diyor",
    testimonials_sub: "Atölyemizden gerçek deneyimler",
    visit_title: "Atölyemizi ziyaret edin",
    plan_appointment: "Randevu planla",
    discover_collection: "Koleksiyonu keşfet",
    view_all: "Tümünü gör",
    read_more: "Devamını oku",
    learn_more: "Daha fazla",
    back_to_blog: "Dergiye dön",
    no_products_yet: "Çok yakında. Kişisel danışmanlık için randevu alın.",
    blog_title: "Dergi & İlham",
    blog_sub: "Özel gününüz için ipuçları, trendler ve hikâyeler",
    content_tab: "İçerik",
    products_tab: "Koleksiyonlar",
    blog_tab: "Dergi",
    theme_tab: "Renkler",
    testimonials_tab: "Yorumlar",
    add_item: "Ekle",
    title_label: "Başlık",
    description_label: "Açıklama",
    image_label: "Görsel",
    body_label: "İçerik",
    excerpt_label: "Özet",
    published_label: "Yayında",
    order_label: "Sıra",
    delete_label: "Sil",
    edit_label: "Düzenle",
    cancel_label: "İptal",
    rating_label: "Yıldız",
    name_label: "İsim",
    edit_language: "Düzenlenen dil",
    hero_title_label: "Hero başlık",
    hero_subtitle_label: "Hero alt başlık",
    about_title_label: "Hakkımızda – başlık",
    about_text_label: "Hakkımızda – metin",
    subcategory_label: "Alt kategori (opsiyonel)",
    social_label: "Sosyal medya",
    theme_gold: "Altın / Vurgu",
    theme_gold_light: "Açık altın",
    theme_dark_bg: "Koyu – arka plan",
    theme_dark_card: "Koyu – kartlar",
    theme_dark_text: "Koyu – metin",
    theme_dark_muted: "Koyu – metin soluk",
    theme_light_bg: "Açık – arka plan",
    theme_light_card: "Açık – kartlar",
    theme_light_text: "Açık – metin",
    theme_light_muted: "Açık – metin soluk",
    pages_tab: "Sayfalar",
    page_new: "Yeni sayfa",
    page_back: "Geri",
    page_title_ph: "Sayfa başlığı",
    page_hero: "Kapak görseli (opsiyonel)",
    page_show_nav: "Menüde",
    page_published: "Yayında",
    page_add_heading: "Başlık",
    page_add_text: "Metin",
    page_add_image: "Görsel",
    page_block_caption: "Açıklama (opsiyonel)",
    page_no_pages: "Henüz sayfa yok. İlk sayfanızı oluşturun.",
    page_delete_confirm: "Bu sayfa gerçekten silinsin mi?",
    page_not_found: "Sayfa bulunamadı",
    img_hero: "Hero görseli",
    img_store: "Atölye",
    view_image: "Görseli gör",
  },
};

export const CATEGORY_KEYS = ["brautmode", "abendkleider", "hennakleidung", "verlobungskleidung", "herrenanzuege"];
